// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ============================================
   Admin Management - Enterprise Corporate Design
   Matching GameManagement Theme
   ============================================ */

/* CSS Variables - Matching GameManagement Theme */
:root {
  --admin-management-bg: #f8f9fa;
  --admin-management-text: #000000;
  --admin-management-text-muted: #4a5568;
  --admin-management-border: rgba(135, 206, 235, 0.3);
  --light-sky-blue: #87ceeb;
  --light-red: #ff6b6b;
  --white: #ffffff;
  --navy-blue: #001f3f;
  --transition: all 0.2s ease;
}

/* ============================================
   Main Container
   ============================================ */
.AdminManagement_adminManagement__ms4Cn {
  min-height: calc(100vh - 60px);
  background: var(--admin-management-bg);
  padding: 1.5rem;
  color: var(--admin-management-text);
  width: 100%;
  max-width: 100%;
  overflow-x: hidden;
  box-sizing: border-box;
}

/* ============================================
   Header
   ============================================ */
.AdminManagement_header__ydPWd {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 1.5rem;
  flex-wrap: wrap;
  gap: 1rem;
}

.AdminManagement_headerLeft__ItCb1 {
  display: flex;
  align-items: center;
  gap: 0.75rem;
}

.AdminManagement_headerIcon__ZPALw {
  color: var(--light-sky-blue);
}

.AdminManagement_title__hjXbU {
  font-size: 1.5rem;
  font-weight: 700;
  color: var(--admin-management-text);
  margin: 0;
  letter-spacing: 0.1em;
  text-transform: uppercase;
}

.AdminManagement_addButton__JY7T2 {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.625rem 1.25rem;
  background: #000000;
  color: var(--white);
  border: none;
  border-radius: 0.375rem;
  font-size: 0.875rem;
  font-weight: 600;
  cursor: pointer;
  transition: var(--transition);
}

.AdminManagement_addButton__JY7T2:hover {
  background: #001f3f;
  transform: translateY(-1px);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);
}

.AdminManagement_addButton__JY7T2:active {
  transform: translateY(0);
}

/* ============================================
   Notification
   ============================================ */
.AdminManagement_notification__FgOIP {
  padding: 0.875rem 1rem;
  border-radius: 0.5rem;
  margin-bottom: 1.5rem;
  font-weight: 500;
  animation: AdminManagement_slideDown__AnVrW 0.3s ease;
}

.AdminManagement_notificationSuccess__dthZ5,
.AdminManagement_notificationsuccess__OR6is {
  background: rgba(67, 160, 71, 0.1);
  color: #43a047;
  border: 1px solid rgba(67, 160, 71, 0.3);
}

.AdminManagement_notificationError__Pbniu,
.AdminManagement_notificationerror__sTMaA {
  background: rgba(255, 107, 107, 0.1);
  color: var(--light-red);
  border: 1px solid rgba(255, 107, 107, 0.3);
}

@keyframes AdminManagement_slideDown__AnVrW {
  from {
    opacity: 0;
    transform: translateY(-10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* ============================================
   Loading & Error States
   ============================================ */
.AdminManagement_loadingContainer__BdQzv {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 400px;
}

.AdminManagement_spinner__iaUa0 {
  color: var(--light-sky-blue);
  animation: AdminManagement_spin__yYKAv 1s linear infinite;
}

@keyframes AdminManagement_spin__yYKAv {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}

.AdminManagement_errorAlert__fewE6 {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  padding: 1rem;
  background: var(--light-red);
  color: white;
  border-radius: 0.5rem;
  margin-bottom: 1.5rem;
  font-weight: 500;
}

.AdminManagement_errorAlert__fewE6 svg {
  flex-shrink: 0;
}

/* ============================================
   Table Container
   ============================================ */
.AdminManagement_searchBarRow__JMcdG {
  margin-bottom: 1rem;
}

.AdminManagement_tableContainer__NqIo- {
  background: var(--white);
  border: 1px solid var(--admin-management-border);
  border-radius: 0.5rem;
  overflow-x: auto;
  overflow-y: visible;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
}

.AdminManagement_table__kIH5N {
  width: 100%;
  border-collapse: collapse;
  min-width: 800px;
}

.AdminManagement_table__kIH5N thead {
  background: linear-gradient(135deg, #000000 0%, #001f3f 50%, #000000 100%);
  background-color: #000000;
  color: #ffffff;
}

.AdminManagement_table__kIH5N th {
  padding: 1rem;
  text-align: left;
  font-size: 0.875rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  border-bottom: 2px solid rgba(255, 255, 255, 0.1);
  background: linear-gradient(135deg, #000000 0%, #001f3f 50%, #000000 100%);
  background-color: #000000;
  color: #ffffff;
  white-space: nowrap;
}

.AdminManagement_table__kIH5N tbody tr {
  border-bottom: 1px solid var(--admin-management-border);
  transition: var(--transition);
}

.AdminManagement_table__kIH5N tbody tr:hover {
  background: rgba(135, 206, 235, 0.05);
}

.AdminManagement_table__kIH5N tbody tr:last-child {
  border-bottom: none;
}

.AdminManagement_table__kIH5N td {
  padding: 1rem;
  font-size: 0.875rem;
  color: var(--admin-management-text);
  white-space: nowrap;
}

.AdminManagement_emptyState__8C-DV {
  text-align: center;
  padding: 3rem 1rem;
  color: var(--admin-management-text-muted);
  font-style: italic;
}

/* ============================================
   Status Badge
   ============================================ */
.AdminManagement_statusBadge__4SZtz {
  display: inline-block;
  padding: 0.25rem 0.75rem;
  border-radius: 1rem;
  font-size: 0.75rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.05em;
}

.AdminManagement_statusActive__oGgP\\+ {
  background: rgba(67, 160, 71, 0.1);
  color: #43a047;
}

.AdminManagement_statusInactive__5V\\+eS {
  background: rgba(255, 107, 107, 0.1);
  color: var(--light-red);
}

/* ============================================
   Action Buttons
   ============================================ */
.AdminManagement_actionButtons__WZhu7 {
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.AdminManagement_passwordCell__iiAI1 {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.75rem;
}

.AdminManagement_passwordValue__S7Ico {
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 180px;
}

.AdminManagement_iconButton__FxsBW {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  padding: 0;
  background: transparent;
  border: 1px solid var(--admin-management-border);
  border-radius: 0.375rem;
  color: var(--admin-management-text);
  cursor: pointer;
  transition: var(--transition);
}

.AdminManagement_iconButton__FxsBW:hover {
  background: rgba(135, 206, 235, 0.1);
  border-color: var(--light-sky-blue);
  color: var(--light-sky-blue);
}

.AdminManagement_iconButton__FxsBW:active {
  transform: scale(0.95);
}

.AdminManagement_balanceCheckOn__gvaWE {
  color: #16a34a;
}

.AdminManagement_balanceCheckOff__q3bek {
  color: #94a3b8;
}

.AdminManagement_deleteButton__zHJAf:hover {
  background: rgba(255, 107, 107, 0.1);
  border-color: var(--light-red);
  color: var(--light-red);
}

/* ============================================
   Modal
   ============================================ */
.AdminManagement_modalOverlay__KrQ3X {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  padding: 1rem;
  backdrop-filter: blur(2px);
  -webkit-backdrop-filter: blur(2px);
}

.AdminManagement_modal__lL1tC {
  background: var(--white);
  border-radius: 0.5rem;
  width: 100%;
  max-width: 800px;
  max-height: calc(100vh - 2rem);
  max-height: calc(100dvh - 2rem);
  display: flex;
  flex-direction: column;
  overflow: hidden;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.2);
}

.AdminManagement_modalForm__SgIga {
  flex: 1 1;
  min-height: 0;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.AdminManagement_modalHeader__blGRB {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 1.25rem 1.5rem;
  background: linear-gradient(135deg, #000000 0%, #001f3f 50%, #000000 100%);
  color: var(--white);
  border-radius: 0.5rem 0.5rem 0 0;
  flex-shrink: 0;
}

.AdminManagement_modalTitle__5piQB {
  font-size: 1.125rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.1em;
  margin: 0;
}

.AdminManagement_closeButton__Deu3B {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  padding: 0;
  background: transparent;
  border: none;
  color: var(--white);
  cursor: pointer;
  border-radius: 0.25rem;
  transition: var(--transition);
}

.AdminManagement_closeButton__Deu3B:hover {
  background: rgba(255, 255, 255, 0.1);
}

.AdminManagement_modalBody__r\\+CwW {
  padding: 1.5rem;
  flex: 1 1;
  min-height: 0;
  overflow-y: auto;
  overflow-x: hidden;
  overscroll-behavior: contain;
}

.AdminManagement_modalFooter__aY4Qf {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 0.75rem;
  padding: 1.25rem 1.5rem;
  border-top: 1px solid var(--admin-management-border);
  background: #f8f9fa;
  border-radius: 0 0 0.5rem 0.5rem;
  flex-shrink: 0;
}

/* ============================================
   Form Elements
   ============================================ */
.AdminManagement_formGroup__fh9fz {
  margin-bottom: 1.25rem;
}

.AdminManagement_label__NB\\+ix {
  display: block;
  font-size: 0.875rem;
  font-weight: 600;
  color: var(--admin-management-text);
  margin-bottom: 0.5rem;
  text-transform: uppercase;
  letter-spacing: 0.05em;
}

.AdminManagement_required__2hHhT {
  color: var(--light-red);
}

.AdminManagement_input__mq4vt,
.AdminManagement_select__bAPJe {
  width: 100%;
  padding: 0.625rem 0.875rem;
  font-size: 0.875rem;
  border: 1px solid var(--admin-management-border);
  border-radius: 0.375rem;
  background: var(--white);
  color: var(--admin-management-text);
  transition: var(--transition);
  box-sizing: border-box;
}

.AdminManagement_input__mq4vt:focus,
.AdminManagement_select__bAPJe:focus {
  outline: none;
  border-color: var(--light-sky-blue);
  box-shadow: 0 0 0 3px rgba(135, 206, 235, 0.1);
}

.AdminManagement_input__mq4vt::placeholder {
  color: var(--admin-management-text-muted);
}

.AdminManagement_select__bAPJe {
  cursor: pointer;
}

.AdminManagement_switchLabel__5MPIe {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  cursor: pointer;
  padding: 0.5rem 0;
}

.AdminManagement_switch__Rv\\+er {
  width: 40px;
  height: 20px;
  appearance: none;
  background: #cbd5e0;
  border-radius: 10px;
  position: relative;
  cursor: pointer;
  transition: var(--transition);
  flex-shrink: 0;
}

.AdminManagement_switch__Rv\\+er:checked {
  background: var(--light-sky-blue);
}

.AdminManagement_switch__Rv\\+er::before {
  content: '';
  position: absolute;
  width: 16px;
  height: 16px;
  border-radius: 50%;
  background: var(--white);
  top: 2px;
  left: 2px;
  transition: var(--transition);
}

.AdminManagement_switch__Rv\\+er:checked::before {
  left: 22px;
}

.AdminManagement_switchText__Y5q2i {
  font-size: 0.875rem;
  font-weight: 500;
  color: var(--admin-management-text);
}

.AdminManagement_helpText__tC9t6 {
  font-size: 0.8125rem;
  color: var(--admin-management-text-muted);
  margin-left: 0.5rem;
  font-weight: normal;
  text-transform: none;
}

.AdminManagement_submitButton__HEbMb {
  padding: 0.625rem 1.5rem;
  background: var(--light-sky-blue);
  color: var(--white);
  border: none;
  border-radius: 0.375rem;
  font-size: 0.875rem;
  font-weight: 600;
  cursor: pointer;
  transition: var(--transition);
}

.AdminManagement_submitButton__HEbMb:hover {
  background: #6bb6d4;
  transform: translateY(-1px);
  box-shadow: 0 2px 8px rgba(135, 206, 235, 0.3);
}

.AdminManagement_submitButton__HEbMb:active {
  transform: translateY(0);
}

.AdminManagement_cancelButton__XJdC0 {
  padding: 0.625rem 1.5rem;
  background: transparent;
  color: var(--admin-management-text);
  border: 1px solid var(--admin-management-border);
  border-radius: 0.375rem;
  font-size: 0.875rem;
  font-weight: 600;
  cursor: pointer;
  transition: var(--transition);
}

.AdminManagement_cancelButton__XJdC0:hover {
  background: rgba(135, 206, 235, 0.1);
  border-color: var(--light-sky-blue);
}

/* ============================================
   Responsive Design - Tablet
   ============================================ */
@media (max-width: 1024px) {
  .AdminManagement_adminManagement__ms4Cn {
    padding: 1.25rem;
  }

  .AdminManagement_title__hjXbU {
    font-size: 1.25rem;
  }

  .AdminManagement_table__kIH5N th,
  .AdminManagement_table__kIH5N td {
    padding: 0.875rem;
    font-size: 0.8125rem;
  }

  .AdminManagement_modal__lL1tC {
    max-width: 95%;
  }
}

/* ============================================
   Responsive Design - Mobile
   ============================================ */
@media (max-width: 768px) {
  .AdminManagement_adminManagement__ms4Cn {
    padding: 1rem;
  }

  .AdminManagement_header__ydPWd {
    flex-direction: column;
    align-items: flex-start;
  }

  .AdminManagement_title__hjXbU {
    font-size: 1.125rem;
  }

  .AdminManagement_addButton__JY7T2 {
    width: 100%;
    justify-content: center;
  }

  .AdminManagement_tableContainer__NqIo- {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }

  .AdminManagement_table__kIH5N {
    min-width: 700px;
  }

  .AdminManagement_table__kIH5N th,
  .AdminManagement_table__kIH5N td {
    padding: 0.75rem 0.5rem;
    font-size: 0.75rem;
  }

  .AdminManagement_modal__lL1tC {
    max-width: 100%;
    max-height: calc(100vh - 3rem);
    max-height: calc(100dvh - 3rem);
    margin: 0.5rem;
  }

  .AdminManagement_modalHeader__blGRB {
    padding: 1rem;
  }

  .AdminManagement_modalTitle__5piQB {
    font-size: 1rem;
  }

  .AdminManagement_modalBody__r\\+CwW {
    padding: 1rem;
  }

  .AdminManagement_modalFooter__aY4Qf {
    padding: 1rem;
    flex-direction: column;
  }

  .AdminManagement_submitButton__HEbMb,
  .AdminManagement_cancelButton__XJdC0 {
    width: 100%;
  }
}

/* ============================================
   Responsive Design - Small Mobile
   ============================================ */
@media (max-width: 480px) {
  .AdminManagement_adminManagement__ms4Cn {
    padding: 0.75rem;
  }

  .AdminManagement_title__hjXbU {
    font-size: 1rem;
  }

  .AdminManagement_table__kIH5N {
    min-width: 600px;
  }

  .AdminManagement_table__kIH5N th,
  .AdminManagement_table__kIH5N td {
    padding: 0.625rem 0.375rem;
    font-size: 0.6875rem;
  }

  .AdminManagement_iconButton__FxsBW {
    width: 28px;
    height: 28px;
  }

  .AdminManagement_iconButton__FxsBW svg {
    width: 16px;
    height: 16px;
  }

  .AdminManagement_modalHeader__blGRB {
    padding: 0.875rem;
  }

  .AdminManagement_modalBody__r\\+CwW {
    padding: 0.875rem;
  }

  .AdminManagement_modalFooter__aY4Qf {
    padding: 0.875rem;
  }
}

/* ============================================
   Accessibility
   ============================================ */
@media (prefers-reduced-motion: reduce) {
  * {
    transition-duration: 0.01ms !important;
    animation-duration: 0.01ms !important;
  }
}

.AdminManagement_iconButton__FxsBW:focus-visible,
.AdminManagement_addButton__JY7T2:focus-visible,
.AdminManagement_submitButton__HEbMb:focus-visible,
.AdminManagement_cancelButton__XJdC0:focus-visible,
.AdminManagement_closeButton__Deu3B:focus-visible,
.AdminManagement_input__mq4vt:focus-visible,
.AdminManagement_select__bAPJe:focus-visible,
.AdminManagement_switch__Rv\\+er:focus-visible {
  outline: 2px solid var(--light-sky-blue);
  outline-offset: 2px;
}

.AdminManagement_modalBody__r\\+CwW::-webkit-scrollbar {
  width: 8px;
}

.AdminManagement_modalBody__r\\+CwW::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 4px;
}

.AdminManagement_modalBody__r\\+CwW::-webkit-scrollbar-thumb {
  background: var(--light-sky-blue);
  border-radius: 4px;
}

.AdminManagement_modalBody__r\\+CwW::-webkit-scrollbar-thumb:hover {
  background: #6bb6d4;
}

`, "",{"version":3,"sources":["webpack://./src/styles/AdminManagement.module.css"],"names":[],"mappings":"AAAA;;;iDAGiD;;AAEjD,kDAAkD;AAClD;EACE,8BAA8B;EAC9B,gCAAgC;EAChC,sCAAsC;EACtC,mDAAmD;EACnD,yBAAyB;EACzB,oBAAoB;EACpB,gBAAgB;EAChB,oBAAoB;EACpB,2BAA2B;AAC7B;;AAEA;;iDAEiD;AACjD;EACE,8BAA8B;EAC9B,sCAAsC;EACtC,eAAe;EACf,mCAAmC;EACnC,WAAW;EACX,eAAe;EACf,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;;iDAEiD;AACjD;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,qBAAqB;EACrB,eAAe;EACf,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,mCAAmC;EACnC,SAAS;EACT,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,yBAAyB;EACzB,mBAAmB;EACnB,mBAAmB;EACnB,YAAY;EACZ,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,6BAA6B;AAC/B;;AAEA;EACE,mBAAmB;EACnB,2BAA2B;EAC3B,wCAAwC;AAC1C;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;;iDAEiD;AACjD;EACE,sBAAsB;EACtB,qBAAqB;EACrB,qBAAqB;EACrB,gBAAgB;EAChB,qDAA8B;AAChC;;AAEA;;EAEE,kCAAkC;EAClC,cAAc;EACd,wCAAwC;AAC1C;;AAEA;;EAEE,oCAAoC;EACpC,uBAAuB;EACvB,0CAA0C;AAC5C;;AAEA;EACE;IACE,UAAU;IACV,4BAA4B;EAC9B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;;iDAEiD;AACjD;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;AACnB;;AAEA;EACE,4BAA4B;EAC5B,yDAAkC;AACpC;;AAEA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,aAAa;EACb,4BAA4B;EAC5B,YAAY;EACZ,qBAAqB;EACrB,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;;iDAEiD;AACjD;EACE,mBAAmB;AACrB;;AAEA;EACE,wBAAwB;EACxB,gDAAgD;EAChD,qBAAqB;EACrB,gBAAgB;EAChB,mBAAmB;EACnB,yCAAyC;AAC3C;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,0EAA0E;EAC1E,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,iDAAiD;EACjD,0EAA0E;EAC1E,yBAAyB;EACzB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,uDAAuD;EACvD,6BAA6B;AAC/B;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mCAAmC;EACnC,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,yCAAyC;EACzC,kBAAkB;AACpB;;AAEA;;iDAEiD;AACjD;EACE,qBAAqB;EACrB,wBAAwB;EACxB,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,kCAAkC;EAClC,cAAc;AAChB;;AAEA;EACE,oCAAoC;EACpC,uBAAuB;AACzB;;AAEA;;iDAEiD;AACjD;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,YAAY;AACd;;AAEA;EACE,+GAA+G;EAC/G,gBAAgB;EAChB,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,UAAU;EACV,uBAAuB;EACvB,gDAAgD;EAChD,uBAAuB;EACvB,mCAAmC;EACnC,eAAe;EACf,6BAA6B;AAC/B;;AAEA;EACE,oCAAoC;EACpC,mCAAmC;EACnC,4BAA4B;AAC9B;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,oCAAoC;EACpC,8BAA8B;EAC9B,uBAAuB;AACzB;;AAEA;;iDAEiD;AACjD;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,8BAA8B;EAC9B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,aAAa;EACb,0BAA0B;EAC1B,kCAAkC;AACpC;;AAEA;EACE,wBAAwB;EACxB,qBAAqB;EACrB,WAAW;EACX,gBAAgB;EAChB,8BAA8B;EAC9B,+BAA+B;EAC/B,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,0CAA0C;AAC5C;;AAEA;EACE,SAAO;EACP,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,uBAAuB;EACvB,0EAA0E;EAC1E,mBAAmB;EACnB,gCAAgC;EAChC,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;EACrB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,UAAU;EACV,uBAAuB;EACvB,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,sBAAsB;EACtB,6BAA6B;AAC/B;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,eAAe;EACf,SAAO;EACP,aAAa;EACb,gBAAgB;EAChB,kBAAkB;EAClB,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,YAAY;EACZ,uBAAuB;EACvB,oDAAoD;EACpD,mBAAmB;EACnB,gCAAgC;EAChC,cAAc;AAChB;;AAEA;;iDAEiD;AACjD;EACE,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,mCAAmC;EACnC,qBAAqB;EACrB,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;;EAEE,WAAW;EACX,0BAA0B;EAC1B,mBAAmB;EACnB,gDAAgD;EAChD,uBAAuB;EACvB,wBAAwB;EACxB,mCAAmC;EACnC,6BAA6B;EAC7B,sBAAsB;AACxB;;AAEA;;EAEE,aAAa;EACb,mCAAmC;EACnC,8CAA8C;AAChD;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,mBAAmB;EACnB,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,6BAA6B;EAC7B,cAAc;AAChB;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,wBAAwB;EACxB,QAAQ;EACR,SAAS;EACT,6BAA6B;AAC/B;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,mCAAmC;AACrC;;AAEA;EACE,oBAAoB;EACpB,yCAAyC;EACzC,mBAAmB;EACnB,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,wBAAwB;EACxB,iCAAiC;EACjC,mBAAmB;EACnB,YAAY;EACZ,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,6BAA6B;AAC/B;;AAEA;EACE,mBAAmB;EACnB,2BAA2B;EAC3B,8CAA8C;AAChD;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,wBAAwB;EACxB,uBAAuB;EACvB,mCAAmC;EACnC,gDAAgD;EAChD,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,6BAA6B;AAC/B;;AAEA;EACE,oCAAoC;EACpC,mCAAmC;AACrC;;AAEA;;iDAEiD;AACjD;EACE;IACE,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;;IAEE,iBAAiB;IACjB,oBAAoB;EACtB;;EAEA;IACE,cAAc;EAChB;AACF;;AAEA;;iDAEiD;AACjD;EACE;IACE,aAAa;EACf;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;EACzB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,WAAW;IACX,uBAAuB;EACzB;;EAEA;IACE,gBAAgB;IAChB,iCAAiC;EACnC;;EAEA;IACE,gBAAgB;EAClB;;EAEA;;IAEE,uBAAuB;IACvB,kBAAkB;EACpB;;EAEA;IACE,eAAe;IACf,8BAA8B;IAC9B,+BAA+B;IAC/B,cAAc;EAChB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;IACb,sBAAsB;EACxB;;EAEA;;IAEE,WAAW;EACb;AACF;;AAEA;;iDAEiD;AACjD;EACE;IACE,gBAAgB;EAClB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;;IAEE,0BAA0B;IAC1B,oBAAoB;EACtB;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;AACF;;AAEA;;iDAEiD;AACjD;EACE;IACE,sCAAsC;IACtC,qCAAqC;EACvC;AACF;;AAEA;;;;;;;;EAQE,wCAAwC;EACxC,mBAAmB;AACrB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,iCAAiC;EACjC,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB","sourcesContent":["/* ============================================\n   Admin Management - Enterprise Corporate Design\n   Matching GameManagement Theme\n   ============================================ */\n\n/* CSS Variables - Matching GameManagement Theme */\n:root {\n  --admin-management-bg: #f8f9fa;\n  --admin-management-text: #000000;\n  --admin-management-text-muted: #4a5568;\n  --admin-management-border: rgba(135, 206, 235, 0.3);\n  --light-sky-blue: #87ceeb;\n  --light-red: #ff6b6b;\n  --white: #ffffff;\n  --navy-blue: #001f3f;\n  --transition: all 0.2s ease;\n}\n\n/* ============================================\n   Main Container\n   ============================================ */\n.adminManagement {\n  min-height: calc(100vh - 60px);\n  background: var(--admin-management-bg);\n  padding: 1.5rem;\n  color: var(--admin-management-text);\n  width: 100%;\n  max-width: 100%;\n  overflow-x: hidden;\n  box-sizing: border-box;\n}\n\n/* ============================================\n   Header\n   ============================================ */\n.header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin-bottom: 1.5rem;\n  flex-wrap: wrap;\n  gap: 1rem;\n}\n\n.headerLeft {\n  display: flex;\n  align-items: center;\n  gap: 0.75rem;\n}\n\n.headerIcon {\n  color: var(--light-sky-blue);\n}\n\n.title {\n  font-size: 1.5rem;\n  font-weight: 700;\n  color: var(--admin-management-text);\n  margin: 0;\n  letter-spacing: 0.1em;\n  text-transform: uppercase;\n}\n\n.addButton {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  padding: 0.625rem 1.25rem;\n  background: #000000;\n  color: var(--white);\n  border: none;\n  border-radius: 0.375rem;\n  font-size: 0.875rem;\n  font-weight: 600;\n  cursor: pointer;\n  transition: var(--transition);\n}\n\n.addButton:hover {\n  background: #001f3f;\n  transform: translateY(-1px);\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);\n}\n\n.addButton:active {\n  transform: translateY(0);\n}\n\n/* ============================================\n   Notification\n   ============================================ */\n.notification {\n  padding: 0.875rem 1rem;\n  border-radius: 0.5rem;\n  margin-bottom: 1.5rem;\n  font-weight: 500;\n  animation: slideDown 0.3s ease;\n}\n\n.notificationSuccess,\n.notificationsuccess {\n  background: rgba(67, 160, 71, 0.1);\n  color: #43a047;\n  border: 1px solid rgba(67, 160, 71, 0.3);\n}\n\n.notificationError,\n.notificationerror {\n  background: rgba(255, 107, 107, 0.1);\n  color: var(--light-red);\n  border: 1px solid rgba(255, 107, 107, 0.3);\n}\n\n@keyframes slideDown {\n  from {\n    opacity: 0;\n    transform: translateY(-10px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n/* ============================================\n   Loading & Error States\n   ============================================ */\n.loadingContainer {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  min-height: 400px;\n}\n\n.spinner {\n  color: var(--light-sky-blue);\n  animation: spin 1s linear infinite;\n}\n\n@keyframes spin {\n  from {\n    transform: rotate(0deg);\n  }\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n.errorAlert {\n  display: flex;\n  align-items: center;\n  gap: 0.75rem;\n  padding: 1rem;\n  background: var(--light-red);\n  color: white;\n  border-radius: 0.5rem;\n  margin-bottom: 1.5rem;\n  font-weight: 500;\n}\n\n.errorAlert svg {\n  flex-shrink: 0;\n}\n\n/* ============================================\n   Table Container\n   ============================================ */\n.searchBarRow {\n  margin-bottom: 1rem;\n}\n\n.tableContainer {\n  background: var(--white);\n  border: 1px solid var(--admin-management-border);\n  border-radius: 0.5rem;\n  overflow-x: auto;\n  overflow-y: visible;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);\n}\n\n.table {\n  width: 100%;\n  border-collapse: collapse;\n  min-width: 800px;\n}\n\n.table thead {\n  background: linear-gradient(135deg, #000000 0%, #001f3f 50%, #000000 100%);\n  background-color: #000000;\n  color: #ffffff;\n}\n\n.table th {\n  padding: 1rem;\n  text-align: left;\n  font-size: 0.875rem;\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 0.05em;\n  border-bottom: 2px solid rgba(255, 255, 255, 0.1);\n  background: linear-gradient(135deg, #000000 0%, #001f3f 50%, #000000 100%);\n  background-color: #000000;\n  color: #ffffff;\n  white-space: nowrap;\n}\n\n.table tbody tr {\n  border-bottom: 1px solid var(--admin-management-border);\n  transition: var(--transition);\n}\n\n.table tbody tr:hover {\n  background: rgba(135, 206, 235, 0.05);\n}\n\n.table tbody tr:last-child {\n  border-bottom: none;\n}\n\n.table td {\n  padding: 1rem;\n  font-size: 0.875rem;\n  color: var(--admin-management-text);\n  white-space: nowrap;\n}\n\n.emptyState {\n  text-align: center;\n  padding: 3rem 1rem;\n  color: var(--admin-management-text-muted);\n  font-style: italic;\n}\n\n/* ============================================\n   Status Badge\n   ============================================ */\n.statusBadge {\n  display: inline-block;\n  padding: 0.25rem 0.75rem;\n  border-radius: 1rem;\n  font-size: 0.75rem;\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: 0.05em;\n}\n\n.statusActive {\n  background: rgba(67, 160, 71, 0.1);\n  color: #43a047;\n}\n\n.statusInactive {\n  background: rgba(255, 107, 107, 0.1);\n  color: var(--light-red);\n}\n\n/* ============================================\n   Action Buttons\n   ============================================ */\n.actionButtons {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n}\n\n.passwordCell {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 0.75rem;\n}\n\n.passwordValue {\n  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, \"Liberation Mono\", \"Courier New\", monospace;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  max-width: 180px;\n}\n\n.iconButton {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 32px;\n  height: 32px;\n  padding: 0;\n  background: transparent;\n  border: 1px solid var(--admin-management-border);\n  border-radius: 0.375rem;\n  color: var(--admin-management-text);\n  cursor: pointer;\n  transition: var(--transition);\n}\n\n.iconButton:hover {\n  background: rgba(135, 206, 235, 0.1);\n  border-color: var(--light-sky-blue);\n  color: var(--light-sky-blue);\n}\n\n.iconButton:active {\n  transform: scale(0.95);\n}\n\n.balanceCheckOn {\n  color: #16a34a;\n}\n\n.balanceCheckOff {\n  color: #94a3b8;\n}\n\n.deleteButton:hover {\n  background: rgba(255, 107, 107, 0.1);\n  border-color: var(--light-red);\n  color: var(--light-red);\n}\n\n/* ============================================\n   Modal\n   ============================================ */\n.modalOverlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: rgba(0, 0, 0, 0.5);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 1000;\n  padding: 1rem;\n  backdrop-filter: blur(2px);\n  -webkit-backdrop-filter: blur(2px);\n}\n\n.modal {\n  background: var(--white);\n  border-radius: 0.5rem;\n  width: 100%;\n  max-width: 800px;\n  max-height: calc(100vh - 2rem);\n  max-height: calc(100dvh - 2rem);\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.2);\n}\n\n.modalForm {\n  flex: 1;\n  min-height: 0;\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n}\n\n.modalHeader {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 1.25rem 1.5rem;\n  background: linear-gradient(135deg, #000000 0%, #001f3f 50%, #000000 100%);\n  color: var(--white);\n  border-radius: 0.5rem 0.5rem 0 0;\n  flex-shrink: 0;\n}\n\n.modalTitle {\n  font-size: 1.125rem;\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 0.1em;\n  margin: 0;\n}\n\n.closeButton {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 32px;\n  height: 32px;\n  padding: 0;\n  background: transparent;\n  border: none;\n  color: var(--white);\n  cursor: pointer;\n  border-radius: 0.25rem;\n  transition: var(--transition);\n}\n\n.closeButton:hover {\n  background: rgba(255, 255, 255, 0.1);\n}\n\n.modalBody {\n  padding: 1.5rem;\n  flex: 1;\n  min-height: 0;\n  overflow-y: auto;\n  overflow-x: hidden;\n  overscroll-behavior: contain;\n}\n\n.modalFooter {\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n  gap: 0.75rem;\n  padding: 1.25rem 1.5rem;\n  border-top: 1px solid var(--admin-management-border);\n  background: #f8f9fa;\n  border-radius: 0 0 0.5rem 0.5rem;\n  flex-shrink: 0;\n}\n\n/* ============================================\n   Form Elements\n   ============================================ */\n.formGroup {\n  margin-bottom: 1.25rem;\n}\n\n.label {\n  display: block;\n  font-size: 0.875rem;\n  font-weight: 600;\n  color: var(--admin-management-text);\n  margin-bottom: 0.5rem;\n  text-transform: uppercase;\n  letter-spacing: 0.05em;\n}\n\n.required {\n  color: var(--light-red);\n}\n\n.input,\n.select {\n  width: 100%;\n  padding: 0.625rem 0.875rem;\n  font-size: 0.875rem;\n  border: 1px solid var(--admin-management-border);\n  border-radius: 0.375rem;\n  background: var(--white);\n  color: var(--admin-management-text);\n  transition: var(--transition);\n  box-sizing: border-box;\n}\n\n.input:focus,\n.select:focus {\n  outline: none;\n  border-color: var(--light-sky-blue);\n  box-shadow: 0 0 0 3px rgba(135, 206, 235, 0.1);\n}\n\n.input::placeholder {\n  color: var(--admin-management-text-muted);\n}\n\n.select {\n  cursor: pointer;\n}\n\n.switchLabel {\n  display: flex;\n  align-items: center;\n  gap: 0.75rem;\n  cursor: pointer;\n  padding: 0.5rem 0;\n}\n\n.switch {\n  width: 40px;\n  height: 20px;\n  appearance: none;\n  background: #cbd5e0;\n  border-radius: 10px;\n  position: relative;\n  cursor: pointer;\n  transition: var(--transition);\n  flex-shrink: 0;\n}\n\n.switch:checked {\n  background: var(--light-sky-blue);\n}\n\n.switch::before {\n  content: '';\n  position: absolute;\n  width: 16px;\n  height: 16px;\n  border-radius: 50%;\n  background: var(--white);\n  top: 2px;\n  left: 2px;\n  transition: var(--transition);\n}\n\n.switch:checked::before {\n  left: 22px;\n}\n\n.switchText {\n  font-size: 0.875rem;\n  font-weight: 500;\n  color: var(--admin-management-text);\n}\n\n.helpText {\n  font-size: 0.8125rem;\n  color: var(--admin-management-text-muted);\n  margin-left: 0.5rem;\n  font-weight: normal;\n  text-transform: none;\n}\n\n.submitButton {\n  padding: 0.625rem 1.5rem;\n  background: var(--light-sky-blue);\n  color: var(--white);\n  border: none;\n  border-radius: 0.375rem;\n  font-size: 0.875rem;\n  font-weight: 600;\n  cursor: pointer;\n  transition: var(--transition);\n}\n\n.submitButton:hover {\n  background: #6bb6d4;\n  transform: translateY(-1px);\n  box-shadow: 0 2px 8px rgba(135, 206, 235, 0.3);\n}\n\n.submitButton:active {\n  transform: translateY(0);\n}\n\n.cancelButton {\n  padding: 0.625rem 1.5rem;\n  background: transparent;\n  color: var(--admin-management-text);\n  border: 1px solid var(--admin-management-border);\n  border-radius: 0.375rem;\n  font-size: 0.875rem;\n  font-weight: 600;\n  cursor: pointer;\n  transition: var(--transition);\n}\n\n.cancelButton:hover {\n  background: rgba(135, 206, 235, 0.1);\n  border-color: var(--light-sky-blue);\n}\n\n/* ============================================\n   Responsive Design - Tablet\n   ============================================ */\n@media (max-width: 1024px) {\n  .adminManagement {\n    padding: 1.25rem;\n  }\n\n  .title {\n    font-size: 1.25rem;\n  }\n\n  .table th,\n  .table td {\n    padding: 0.875rem;\n    font-size: 0.8125rem;\n  }\n\n  .modal {\n    max-width: 95%;\n  }\n}\n\n/* ============================================\n   Responsive Design - Mobile\n   ============================================ */\n@media (max-width: 768px) {\n  .adminManagement {\n    padding: 1rem;\n  }\n\n  .header {\n    flex-direction: column;\n    align-items: flex-start;\n  }\n\n  .title {\n    font-size: 1.125rem;\n  }\n\n  .addButton {\n    width: 100%;\n    justify-content: center;\n  }\n\n  .tableContainer {\n    overflow-x: auto;\n    -webkit-overflow-scrolling: touch;\n  }\n\n  .table {\n    min-width: 700px;\n  }\n\n  .table th,\n  .table td {\n    padding: 0.75rem 0.5rem;\n    font-size: 0.75rem;\n  }\n\n  .modal {\n    max-width: 100%;\n    max-height: calc(100vh - 3rem);\n    max-height: calc(100dvh - 3rem);\n    margin: 0.5rem;\n  }\n\n  .modalHeader {\n    padding: 1rem;\n  }\n\n  .modalTitle {\n    font-size: 1rem;\n  }\n\n  .modalBody {\n    padding: 1rem;\n  }\n\n  .modalFooter {\n    padding: 1rem;\n    flex-direction: column;\n  }\n\n  .submitButton,\n  .cancelButton {\n    width: 100%;\n  }\n}\n\n/* ============================================\n   Responsive Design - Small Mobile\n   ============================================ */\n@media (max-width: 480px) {\n  .adminManagement {\n    padding: 0.75rem;\n  }\n\n  .title {\n    font-size: 1rem;\n  }\n\n  .table {\n    min-width: 600px;\n  }\n\n  .table th,\n  .table td {\n    padding: 0.625rem 0.375rem;\n    font-size: 0.6875rem;\n  }\n\n  .iconButton {\n    width: 28px;\n    height: 28px;\n  }\n\n  .iconButton svg {\n    width: 16px;\n    height: 16px;\n  }\n\n  .modalHeader {\n    padding: 0.875rem;\n  }\n\n  .modalBody {\n    padding: 0.875rem;\n  }\n\n  .modalFooter {\n    padding: 0.875rem;\n  }\n}\n\n/* ============================================\n   Accessibility\n   ============================================ */\n@media (prefers-reduced-motion: reduce) {\n  * {\n    transition-duration: 0.01ms !important;\n    animation-duration: 0.01ms !important;\n  }\n}\n\n.iconButton:focus-visible,\n.addButton:focus-visible,\n.submitButton:focus-visible,\n.cancelButton:focus-visible,\n.closeButton:focus-visible,\n.input:focus-visible,\n.select:focus-visible,\n.switch:focus-visible {\n  outline: 2px solid var(--light-sky-blue);\n  outline-offset: 2px;\n}\n\n.modalBody::-webkit-scrollbar {\n  width: 8px;\n}\n\n.modalBody::-webkit-scrollbar-track {\n  background: #f1f1f1;\n  border-radius: 4px;\n}\n\n.modalBody::-webkit-scrollbar-thumb {\n  background: var(--light-sky-blue);\n  border-radius: 4px;\n}\n\n.modalBody::-webkit-scrollbar-thumb:hover {\n  background: #6bb6d4;\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"adminManagement": `AdminManagement_adminManagement__ms4Cn`,
	"header": `AdminManagement_header__ydPWd`,
	"headerLeft": `AdminManagement_headerLeft__ItCb1`,
	"headerIcon": `AdminManagement_headerIcon__ZPALw`,
	"title": `AdminManagement_title__hjXbU`,
	"addButton": `AdminManagement_addButton__JY7T2`,
	"notification": `AdminManagement_notification__FgOIP`,
	"slideDown": `AdminManagement_slideDown__AnVrW`,
	"notificationSuccess": `AdminManagement_notificationSuccess__dthZ5`,
	"notificationsuccess": `AdminManagement_notificationsuccess__OR6is`,
	"notificationError": `AdminManagement_notificationError__Pbniu`,
	"notificationerror": `AdminManagement_notificationerror__sTMaA`,
	"loadingContainer": `AdminManagement_loadingContainer__BdQzv`,
	"spinner": `AdminManagement_spinner__iaUa0`,
	"spin": `AdminManagement_spin__yYKAv`,
	"errorAlert": `AdminManagement_errorAlert__fewE6`,
	"searchBarRow": `AdminManagement_searchBarRow__JMcdG`,
	"tableContainer": `AdminManagement_tableContainer__NqIo-`,
	"table": `AdminManagement_table__kIH5N`,
	"emptyState": `AdminManagement_emptyState__8C-DV`,
	"statusBadge": `AdminManagement_statusBadge__4SZtz`,
	"statusActive": `AdminManagement_statusActive__oGgP+`,
	"statusInactive": `AdminManagement_statusInactive__5V+eS`,
	"actionButtons": `AdminManagement_actionButtons__WZhu7`,
	"passwordCell": `AdminManagement_passwordCell__iiAI1`,
	"passwordValue": `AdminManagement_passwordValue__S7Ico`,
	"iconButton": `AdminManagement_iconButton__FxsBW`,
	"balanceCheckOn": `AdminManagement_balanceCheckOn__gvaWE`,
	"balanceCheckOff": `AdminManagement_balanceCheckOff__q3bek`,
	"deleteButton": `AdminManagement_deleteButton__zHJAf`,
	"modalOverlay": `AdminManagement_modalOverlay__KrQ3X`,
	"modal": `AdminManagement_modal__lL1tC`,
	"modalForm": `AdminManagement_modalForm__SgIga`,
	"modalHeader": `AdminManagement_modalHeader__blGRB`,
	"modalTitle": `AdminManagement_modalTitle__5piQB`,
	"closeButton": `AdminManagement_closeButton__Deu3B`,
	"modalBody": `AdminManagement_modalBody__r+CwW`,
	"modalFooter": `AdminManagement_modalFooter__aY4Qf`,
	"formGroup": `AdminManagement_formGroup__fh9fz`,
	"label": `AdminManagement_label__NB+ix`,
	"required": `AdminManagement_required__2hHhT`,
	"input": `AdminManagement_input__mq4vt`,
	"select": `AdminManagement_select__bAPJe`,
	"switchLabel": `AdminManagement_switchLabel__5MPIe`,
	"switch": `AdminManagement_switch__Rv+er`,
	"switchText": `AdminManagement_switchText__Y5q2i`,
	"helpText": `AdminManagement_helpText__tC9t6`,
	"submitButton": `AdminManagement_submitButton__HEbMb`,
	"cancelButton": `AdminManagement_cancelButton__XJdC0`
};
export default ___CSS_LOADER_EXPORT___;
